// Versão do app - gerado automaticamente
export const APP_VERSION = '5.49'
export const BUILD_DATE = '01/08/2026, 02:48'
